export default "__VITE_ASSET__a9e77df1__"